import { FetchResult, MutationResult, useMutation } from '@apollo/client';
import { SpotifyCreateData } from 'wb-spotify/app/routes/superGrid/mutator/utils';
import {
	CreateSpotifyAdsDocument,
	CreateSpotifyAdsMutation,
	CreateAdInput,
} from 'wb-spotify/graphql/generated';
import {
	getSpotifyAdVariablesFromSupergridMutation,
} from 'wb-spotify/app/routes/superGrid/mutator/hooks/utils';

const useCreateSpotifyAds = (): [
	(adsInCreation: SpotifyCreateData[]) => Promise<FetchResult<CreateSpotifyAdsMutation>>,
	MutationResult<CreateSpotifyAdsMutation>,
] => {
	const [createSpotifyAds, adsResult] = useMutation(CreateSpotifyAdsDocument, {
		errorPolicy: 'all',
	});

	const onCreateSpotifyAds = async (adsInCreation: SpotifyCreateData[]) => {
		const ads: CreateAdInput[] = adsInCreation.map(
			(ad) => getSpotifyAdVariablesFromSupergridMutation(ad, ad.adStatus),
		);

		const {
			data: adData,
			errors: adErrors,
			...adResultRest
		} = await createSpotifyAds({
			variables: {
				ads,
			},
		});

		return {
			...adResultRest,
			data:   adData,
			errors: adErrors ?? [],
		};
	};

	return [
		onCreateSpotifyAds,
		{
			...adsResult,
			loading: adsResult.loading,
			error:   adsResult.error,
			data:    adsResult.data,
		},
	];
};

export default useCreateSpotifyAds;
